/**
 * "Queue first test" on a new customer's intake banner.
 *
 * `POST /api/jobs` refuses an office job with no job type
 * (JOB_TYPE_REQUIRED), and the banner used to send none, so the button
 * always failed. It now picks the Backflow Test type the same way Book My
 * Test does on the server (`resolveBackflowJobTypeId` in routes/leads.ts):
 * the active `backflow_test` type first, else the first active backflow
 * type by name.
 */
export interface JobTypeOption {
    id: string;
    code: string | null;
    name: string;
    is_active?: boolean;
}

export function pickBackflowTestJobType(types: readonly JobTypeOption[]): JobTypeOption | null {
    const backflow = types
        .filter((t) => t.is_active !== false && (t.code ?? "").toLowerCase().startsWith("backflow"))
        .sort((a, b) => a.name.localeCompare(b.name));
    return backflow.find((t) => (t.code ?? "").toLowerCase() === "backflow_test") ?? backflow[0] ?? null;
}

export const NO_BACKFLOW_TYPE_MESSAGE =
    "There's no Backflow Test job type turned on. Ask an admin to turn one on in Job Types, then try again.";
